import { Link } from "react-router-dom";
import { profile } from "../data/profileData";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="bg-white relative overflow-hidden border-t border-[var(--gold-line)]"
    >
      <div className="max-w-[1640px] mx-auto px-8 sm:px-14 lg:px-20 pt-28 pb-12">
        {/* Gigantic name */}
        <div className="text-center mb-20">
          <div className="font-couture text-[clamp(5rem,17vw,18rem)] leading-[0.84] text-[var(--ink)] tracking-[-0.02em]">
            P · B · Boss
          </div>
          <p className="mt-7 font-marcellus uppercase tracking-[0.5em] text-[0.66rem] text-[var(--gold-deep)]">
            Quality Relationship &nbsp;·&nbsp; Quality Service &nbsp;·&nbsp;
            Quality Life
          </p>
        </div>

        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 pt-16 border-t border-[var(--gold-line-soft)]">
          <div className="lg:col-span-5">
            <p className="font-marcellus uppercase tracking-[0.4em] text-[0.66rem] text-[var(--gold-deep)] mb-5">
              The House of Osaka · Est. 1993
            </p>
            <p className="font-couture-italic text-2xl lg:text-3xl text-[var(--ink)] leading-snug max-w-md">
              Three decades. Twelve enterprises. One enduring philosophy.
            </p>
          </div>

          <div className="lg:col-span-3">
            <p className="font-marcellus uppercase tracking-[0.4em] text-[0.66rem] text-[var(--gold-deep)] mb-6">
              Navigate
            </p>
            <ul className="space-y-3">
              {[
                ["/", "Home", "home"],
                ["/profile", "Profile", "profile"],
                ["/awards", "Honours", "awards"],
                ["/news", "Press", "news"],
                ["/gallery", "Gallery", "gallery"],
                ["/contact", "Contact", "contact"],
              ].map(([to, label, id]) => (
                <li key={to}>
                  <Link
                    to={to}
                    data-testid={`footer-link-${id}`}
                    className="font-couture text-lg text-[var(--ink-soft)] hover:text-[var(--gold-deep)] transition-colors"
                  >
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-4">
            <p className="font-marcellus uppercase tracking-[0.4em] text-[0.66rem] text-[var(--gold-deep)] mb-6">
              Correspondence
            </p>
            <ul className="space-y-6">
              <li>
                <p className="font-marcellus uppercase tracking-[0.34em] text-[0.62rem] text-[var(--ink-muted)] mb-2">
                  Write
                </p>
                <a
                  data-testid="footer-email"
                  href={`mailto:${profile.contact.email}`}
                  className="font-couture text-xl text-[var(--ink)] hover:text-[var(--gold-deep)] transition-colors break-all"
                >
                  {profile.contact.email}
                </a>
              </li>
              <li>
                <p className="font-marcellus uppercase tracking-[0.34em] text-[0.62rem] text-[var(--ink-muted)] mb-2">
                  Visit
                </p>
                <p className="font-couture text-lg text-[var(--ink)]">
                  {profile.contact.location}
                </p>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-7 border-t border-[var(--gold-line-soft)] flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <p className="font-marcellus uppercase tracking-[0.42em] text-[0.62rem] text-[var(--ink-muted)]">
            © {year} Dr. P. B. Boss · All Rights Reserved
          </p>
          <p className="font-couture-italic text-[var(--ink-muted)]">
            Crafted with reverence for the journey.
          </p>
        </div>
      </div>
    </footer>
  );
}
